<template>
  <aside class="t-datepicker-filter-aside">
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.ONE_MONTH }"
      :handleClick="oneMonth"
    >
      {{ labels[filters.ONE_MONTH] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.THREE_MONTHS }"
      :handleClick="threeMonths"
    >
      {{ labels[filters.THREE_MONTHS] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.SIX_MONTHS }"
      :handleClick="sixMonths"
    >
      {{ labels[filters.SIX_MONTHS] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.TWELVE_MONTHS }"
      :handleClick="twelveMonths"
    >
      {{ labels[filters.TWELVE_MONTHS] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.THIS_MONTH }"
      :handleClick="thisMonth"
    >
      {{ labels[filters.THIS_MONTH] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.THIS_QUARTER }"
      :handleClick="thisQuarter"
    >
      {{ labels[filters.THIS_QUARTER] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.THIS_SEMESTER }"
      :handleClick="thisSemester"
    >
      {{ labels[filters.THIS_SEMESTER] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.THIS_YEAR }"
      :handleClick="thisYear"
    >
      {{ labels[filters.THIS_YEAR] }}
    </Button>
    <Button
      type="pill"
      :class="{ 'is-active': activeFilter == filters.ALL_PERIOD }"
      :handleClick="allPeriod"
    >
      {{ labels[filters.ALL_PERIOD] }}
    </Button>
  </aside>
</template>

<script>
import Button from '../Button/Button.vue';
import { getUnixSeconds } from './convert';
import { filters, i18nAsideLabels } from './filters';

export default {
  data() {
    return {
      filters,
    };
  },
  components: {
    Button,
  },
  props: {
    activeFilter: { type: Number, default: 0 },
    locale: {
      type: String,
      default: 'pt-BR',
      validator: (value) => ['en-US', 'es-ES', 'pt-BR'].includes(value),
    },
  },
  computed: {
    labels() {
      return i18nAsideLabels[this.locale];
    },
  },
  emit: ['setFilter'],
  methods: {
    rewindStartMonth(count, filter) {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - count * 1);
      this.emitSetFilter(filter, startDate, endDate);
    },
    setPeriod(periodSize = 1, filter) {
      const today = new Date();

      let firstMonthOfPeriod = today.getMonth() / periodSize;
      firstMonthOfPeriod = Math.floor(firstMonthOfPeriod);

      const startDate = new Date();
      startDate.setMonth(firstMonthOfPeriod * periodSize, 1);

      const endDate = new Date();
      endDate.setMonth(firstMonthOfPeriod * periodSize + periodSize, 0);

      this.emitSetFilter(filter, startDate, endDate);
    },
    oneMonth() {
      this.rewindStartMonth(1, filters.ONE_MONTH);
    },
    threeMonths() {
      this.rewindStartMonth(3, filters.THREE_MONTHS);
    },
    sixMonths() {
      this.rewindStartMonth(6, filters.SIX_MONTHS);
    },
    twelveMonths() {
      this.rewindStartMonth(12, filters.TWELVE_MONTHS);
    },
    thisMonth() {
      this.setPeriod(1, filters.THIS_MONTH);
    },
    thisQuarter() {
      this.setPeriod(3, filters.THIS_QUARTER);
    },
    thisSemester() {
      this.setPeriod(6, filters.THIS_SEMESTER);
    },
    thisYear() {
      this.setPeriod(12, filters.THIS_YEAR);
    },
    allPeriod() {
      this.emitSetFilter(filters.ALL_PERIOD);
    },
    emitSetFilter(filter, startDate, endDate) {
      let dateRange = {};
      if (startDate instanceof Date && endDate instanceof Date) {
        dateRange = {
          start: getUnixSeconds(startDate),
          end: getUnixSeconds(endDate),
        };
      }

      this.$emit('setFilter', {
        dateRange,
        filter,
      });
    },
  },
};
</script>

<style lang="scss">
.t-datepicker-filter-aside {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 140px;
  gap: var(--track-spacing-sm);
}
</style>
